import { getRangeValue, isCommercial, isSuburban, offerTypeFromJsonQuery, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { fillLabelTemplate } from '../../utils/fillLabelTemplate';

const ID = 'totalArea' as const;

export const totalAreaTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const offerType = offerTypeFromJsonQuery(jsonQuery);

    if (isCommercial(offerType)) {
      return null;
    }

    const totalArea = getRangeValue('total_area')(jsonQuery);
    const isSuburbanSearch = isSuburban(offerType);

    if (totalArea === null) {
      return null;
    }

    const template = isSuburbanSearch ? 'Площадь дома %s м²' : 'Общая площадь %s м²';
    const { gte, lte } = totalArea;
    const from = gte ? `от ${gte}` : '';
    const to = lte ? `до ${lte}` : '';

    return [{ label: fillLabelTemplate(template, `${from} ${to}`).trim(), value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['total_area'])(jsonQuery),
};
